var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "date-picker-header-navigation-buttons" },
    [
      _vm._t("navigationArrowLeft", function () {
        return [
          _c("button", {
            staticClass: "vfc-arrow-left",
            class: { "vfc-disabled": !_vm.allowPreDate },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$parent.PreMonth(_vm.oneArrows ? 0 : _vm.calendarKey)
              },
            },
          }),
        ]
      }),
      _vm._v(" "),
      _vm._t("navigationArrowRight", function () {
        return [
          _c("button", {
            staticClass: "vfc-arrow-right",
            class: { "vfc-disabled": !_vm.allowNextDate },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$parent.NextMonth(
                  _vm.oneArrows ? 0 : _vm.calendarKey
                )
              },
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }